import React, { useLayoutEffect, useState } from 'react';
import { Box, Button, Typography, useMediaQuery } from '@mui/material';

function Hero({
  setContactUsOpened,
  setVideoOpened,
}: {
  setContactUsOpened: (s: boolean) => void;
  setVideoOpened: (s: boolean) => void;
}) {
  const [imgWidth, setImgWidth] = useState(2000);
  const isMobile = useMediaQuery('(max-width:800px)');

  useLayoutEffect(() => {
    function updateSize() {
      isMobile
        ? setImgWidth(window.innerWidth / 0.8)
        : setImgWidth(window.innerWidth < 1410 ? window.innerWidth / 0.71 : 2000);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, [isMobile]);

  return (
    <Box
      id="header_anchor"
      sx={{
        backgroundImage: 'url(/images/pattern.svg)',
        backgroundPosition: 'center',
      }}
    >
      <Box
        sx={{
          maxWidth: '1350px',
          margin: 'auto',
          padding: '0 20px',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Typography
          sx={{
            fontSize: isMobile ? '32px' : '56px',
            fontFamily: 'RedHat700',
            color: '#fff',
            maxWidth: '890px',
            textAlign: 'center',
            lineHeight: 'normal',
            marginTop: isMobile ? '89px' : '175px',
          }}
        >
          Empower Your Business with Data-Driven Precision
        </Typography>
        <Typography
          sx={{
            fontSize: isMobile ? '16px' : '20px',
            fontFamily: 'RedHat400',
            color: '#B5B5B5',
            maxWidth: '660px',
            textAlign: 'center',
            marginTop: isMobile ? '10px' : '20px',
            lineHeight: isMobile ? 'normal' : '30px',
          }}
        >
          Unlock the potential of large-scale user data and AI-powered analytics. Our platform provides real-time
          insights to optimize marketing strategies and boost performance.
        </Typography>
        <Box
          sx={{
            width: '100%',
            maxWidth: isMobile ? '400px' : undefined,
            marginTop: '30px',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '10px' : '20px',
            marginBottom: isMobile ? '20px' : undefined,
          }}
        >
          <Button
            onClick={() => {
              setVideoOpened(true);
            }}
            variant="contained"
            sx={{
              backgroundColor: '#FFF',
              borderRadius: '12px',
              padding: isMobile ? '15px 30px' : '20px 40px',
              fontSize: isMobile ? '16px' : '20px',
              fontFamily: 'RedHat800',
              color: '#171717',
              boxShadow: 'none',
              textTransform: 'initial',
              display: 'flex',
              gap: '10px',
              height: isMobile ? '52px' : '66px',
              lineHeight: 'normal',
            }}
          >
            <img src="/images/play.svg" alt="play"></img>
            See the Platform in Action
          </Button>
          <Button
            onClick={() => {
              setContactUsOpened(true);
            }}
            variant="contained"
            sx={{
              backgroundColor: '#247BFE',
              borderRadius: '12px',
              padding: isMobile ? '15px 30px' : '20px 40px',
              fontSize: isMobile ? '16px' : '20px',
              fontFamily: 'RedHat800',
              color: '#FFF',
              height: isMobile ? '52px' : '66px',
              boxShadow: 'none',
              textTransform: 'initial',
              lineHeight: 'normal',
            }}
          >
            Get started
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          maxWidth: '100%',
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <img
          style={{
            width: `${imgWidth}px`,
          }}
          src="/images/intro_image.webp"
          alt="intro"
        ></img>
      </Box>
    </Box>
  );
}

export default Hero;
